import { NavLink, useNavigate } from 'react-router-dom';

import icAward from '@/assets/ic_award.svg';
import icChevron from '@/assets/ic_chevron.svg';
import icCreditCard from '@/assets/ic_credit_card.svg';
import icHistory from '@/assets/ic_history.svg';
// import icClipboard from '@/assets/ic_clipboard.svg';
import icShirt from '@/assets/ic_shirt.png';
import icUser from '@/assets/ic_user.svg';
import ROUTES from '@/router/routes';

const items: {
  id: number;
  label: string;
  icon: string;
  href: string;
}[] = [
  {
    id: 1,
    label: 'Mi equipo',
    icon: icShirt,
    href: ROUTES.editAccount.myTeam,
  },
  {
    id: 2,
    label: 'Mis datos personales',
    icon: icUser,
    href: ROUTES.editAccount.myData,
  },
  {
    id: 3,
    label: 'Mi CBU',
    icon: icCreditCard,
    href: ROUTES.editAccount.myCBU,
  },
  {
    id: 4,
    label: 'Mis diplomas',
    icon: icAward,
    href: ROUTES.editAccount.myAwards,
  },
  {
    id: 5,
    label: 'Mis campañas anteriores',
    icon: icHistory,
    href: ROUTES.editAccount.myHistory,
  },
];

export const SideBar = () => {
  const navigate = useNavigate();

  return (
    <ul
      className={`pt-2 border-r border-gdt-gray-6 md-shadow-[-9px_0px_15px_0px_rgba(0,_0,_0,_0.1)] bg-white h-full`}
    >
      {items.map((item) => (
        <li
          key={item.id}
          className="flex pt-5 px-6  border-b border-gdt-gray-6 pb-5 justify-center cursor-pointer"
          onClick={() => navigate(item.href)}
        >
          <NavLink
            className={({ isActive }: { isActive: boolean }) =>
              `text-sm font-medium flex justify-between flex-1 lg:max-w-[285px] mx-auto  ${
                isActive ? 'text-gdt-blue font-bold' : ''
              }`
            }
            to={item.href}
          >
            <div className="flex gap-x-3 items-center content-center">
              <img
                alt="Gran DT - logo calendario"
                className="w-5 h-5"
                src={item.icon}
              />
              <span>{item.label}</span>
            </div>
            <div className="w-7 h-7 rounded-lg bg-gdt-blue-light2 flex justify-center items-center">
              <img
                alt="Gran DT - flecha derecha"
                className="w-3 h-3"
                src={icChevron}
              />
            </div>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
